import React from 'react';
import '../static/css/singleproduct.css';
import axios from 'axios';
import {NavLink, withRouter} from "react-router-dom";
import AlibabaAds from "./Ads/AlibabaAds";
import {Helmet} from "react-helmet";
import Trending from "./Trending";

var time = new Date();
console.log(time);

const _userId = JSON.parse(localStorage.getItem('UserObject'));

class SingleProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            trending: '',
            location: ''

        };

    }

    componentDidMount() {
        let path = this.props.match.params.id;
        //console.log(path)
        console.log(this.props.match.params.id);
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/item/item/?id=` + path)
            .then((res) => {
                this.setState({data: res.data[0]});
                console.log(this.state.data);
            }).catch(err => {
            console.error(err);
            this.setState({data: null});

        });
        this.getTrends();
    }

    getTrends = () => {
        const location = JSON.parse(localStorage.getItem('location'));
        this.setState({location})
        let url = `${process.env.REACT_APP_BACKEND_URL}/item/trending`;
        if (!location)
            url = url + '?country=United Kingdom'
        if (location && location.city)
            url = url + '?city=' + location.city;

        axios.get(url)
            .then((res) => {
                this.setState({trending: res.data});
            }).catch(err => console.error(err))
    }

    render() {
        const {data, trending, location} = this.state;
        return (
            <div className="container">
                {
                    data !== null | undefined ?
                        <React.Fragment>
                            <Helmet
                                titleTemplate="euBines.com | %s"
                            >
                                <title>{`${data.title} ${data.condition ? data.condition : ''} ${data.category}`}</title>
                                <meta name="description"
                                      content={"euBines.com: Buy and sell something. Use euBines.com to find the products and offers of today. "}/>
                                <meta name="keywords"
                                      content={`euBines.com: Buy from your neighbours and sell something. Use euBines.com to find the products and offers of today. ${data.title} ${data.condition} ${data.category} ${data.description}`}/>
                                <link rel="canonical" href={window.location}/>
                            </Helmet>
                            <div className="row" id="product">

                                <div id="product-detail" className="col-md-8">
                                    <div className="d-flex justify-content-between"
                                         style={{borderBottom: '1px solid gray'}}>
                                        <div>
                                            <p style={{
                                                fontWeight: 'bold',
                                                fontSize: '17px',
                                                marginTop: '15px',
                                                paddingLeft: '5px'
                                            }}>{data !== undefined ? data.title : ''}
                                            </p>
                                            <p className="d-flex align-items-baseline"
                                               style={{
                                                   marginTop: '-15px',
                                                   paddingLeft: '5px',
                                                   fontSize: '14px',
                                                   flexWrap: 'wrap'
                                               }}
                                            >
                                                <i className="fas fa-map-marker-alt"/>
                                                <u>{data !== undefined ? data.city : ''} | </u>
                                                <u> Added on: </u>
                                                <small>{data !== undefined ? data.date : 'Not Add'}</small>
                                            </p>
                                        </div>
                                        <div className="d-flex align-self-center p-3">
                                            £<h5><b>{data !== undefined ? data.price : ''}</b></h5>
                                        </div>
                                    </div>

                                    <div style={{boxShadow: '0 0 3px 1px #70c2fe'}} id="slider"
                                         className="carousel slide"
                                         data-ride="carousel">
                                        <div className="carousel-inner">
                                            {data !== undefined && data.photo.map((img, index) => (
                                                <div key={index}
                                                     className={index === 0 ? "carousel-item active" : "carousel-item"}>
                                                    <img className="item d-block w-100"
                                                         src={`${process.env.REACT_APP_BACKEND_URL}/uploads/` + img}
                                                         alt={img} height="450"/>
                                                </div>
                                            ))}
                                        </div>
                                        <a className="carousel-control-prev" href="#slider" role="button"
                                           data-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"/>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                        <a className="carousel-control-next" href="#slider" role="button"
                                           data-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"/>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </div>
                                    <hr/>
                                    {
                                        data !== undefined && data.views > 0 &&
                                        <div>Post Views: {data.views}</div>
                                    }
                                    <b><p>Description:</p></b>
                                    <p>{data !== undefined ? data.description : ''}</p>
                                    <p style={{color: 'gray', fontSize: '14px', fontFamily: 'calibri'}}>
                                        When you call, don't forget
                                        to mention that you found this ad on euBines.com
                                        I do not wish to be contacted by telemarketers or representatives of any other
                                        website.
                                    </p>

                                </div>

                                <div id="seller-detial" className="col-md-4 px-md-4">
                                    <div id="seller">
                                        <p style={{fontWeight: 'bold', lineHeight: '0px'}}>
                                            <i className="fas fa-user-tie" style={{
                                                color: '#777',
                                                fontSize: '30px'
                                            }}/> &nbsp;&nbsp;{data !== undefined ? data.name : ''}</p>
                                        <p style={{
                                            color: 'green',
                                            lineHeight: '0px',
                                            fontSize: '11px',
                                            paddingLeft: '40px'
                                        }}>Online</p>
                                        <p style={{fontSize: '13px', paddingLeft: '40px', color: 'blue'}}>(Active on
                                            site
                                            since a
                                            year)</p>
                                        {_userId !== null ?
                                            <p style={{textAlign: 'center', fontSize: '18px'}}><i
                                                className="fas fa-phone"/> {data !== undefined ? data.phone : ''}
                                            </p>
                                            : <span className="d-flex justify-content-center">
                                    <i className="fas fa-mobile text-black align-self-center px-2 "/>
                                    <NavLink to={'/user/login'}>
                                        <small>
                                    Login for contact number
                                        </small>
                                    </NavLink>
                                </span>
                                        }

                                    </div>
                                    <div id="message">
                                        <button type="button" id="msg-btn"
                                                onClick={() => alert('Sorry! you are Unable to Send Messages Yet.')}>Message
                                        </button>

                                    </div>
                                    <div id="tips">
                                        <p style={{textAlign: 'center', fontWeight: 'bold'}}>Safety Tips for Buyers</p>
                                        <ol type="1">
                                            <li>Meet seller at a safe location</li>
                                            <li>Check the item before you buy</li>
                                            <li>Pay only after collecting item</li>
                                        </ol>

                                    </div>


                                </div>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="py-4">

                                <h3>Sorry 🙃</h3>
                                <h5>
                                    The ad you are looking for is no longer available. Please see similar ads below.
                                </h5>
                            </div>
                            <Trending/>
                        </React.Fragment>
                }

                <hr/>
                <AlibabaAds/>
            </div>
        );
    }
}

export default withRouter(SingleProduct);



// WEBPACK FOOTER //
// ./src/components/singleProducet.js